module.exports = __webpack_public_path__ + "img/s2_old.f31238d0.jpg";